import * as firebase from 'firebase/app';
import 'firebase/storage';
import 'firebase/auth';
import 'firebase/database';
import 'firebase/analytics';
import callDb from './server';
import store from '../redux/store';
import { reduceStorageUser, increaseStorageUser } from '../redux/actions/userActions';
import firebaseConfig from '../config/firebase.config.json';

export const firebaseApp = firebase.initializeApp(firebaseConfig);

const storage = firebase.storage();
const firebaseAuth = firebase.auth;
const firebaseDb = firebase.database;
const analytics = firebase.analytics();

const createMongoFiles = (files) => {
  const allData = {
      type: 'file',
      dir_id: '',
      files,
      // parent: '',
      // parentList: '',
    };
    callDb(allData, 'files/create').then((result) => {
      const { data } = result;
      console.log('returned data is: ', data);
    }).catch((err) => {
      console.log(err);
    });
};

// below is only used to upload testament as of now; no need to update storage (max file size being 10Mo, no influence)
const uploadFile = (uid, path, file, parent_folders_id = []) => (
  new Promise((resolve, reject) => {
    const metadata = {
      customMetadata: {
        uid,
      },
    };

    const current_folder_id = [...parent_folders_id].pop();

    // force refresh token in order to get user's customClaims; including dek
    firebaseAuth().currentUser.getIdToken(true).then(() => {
      storage.ref(`/${uid}/${path}`).put(file, metadata).then((newFile) => {
        const metas = {
          metadata: newFile.metadata,
          fullPath: newFile.metadata.fullPath,
          name: newFile.metadata.name,
          size: newFile.metadata.size,
          created_at: newFile.metadata.timeCreated,
          type: 'file',
          path,
          parent_folders_id,
          folder_id: current_folder_id,
        };
        // console.log('metas is: ', metas);
        storage.ref(newFile.metadata.fullPath).getDownloadURL().then((url) => {
          metas.url = url;
          // console.log('url is: ', url);
          // store.dispatch(reduceStorageUser(newFile.metadata.size));
          // createMongoFiles([metas]);
          return resolve(metas);
        });
      }).catch((e) => {
        console.log('error uploading file: ', e);
        return reject(new Error('Error uploading file'));
      });
    });
  })
);

const deleteFiles = (uid, path, files) => {
  let fullSize = 0;
  files.forEach((file) => {
    // console.log(file);
    if (file.size) fullSize += parseInt(file.size, 10);
    const delRef = storage.ref(`${uid}/${path}/${file.name}`);
    delRef.delete().then(() => {
      console.log('document was deleted successfully');
    }).catch((error) => {
      console.log('error deleting document', error);
    });
  });
  store.dispatch(increaseStorageUser(fullSize));
};

/* eslint-disable consistent-return */
const uploadFiles = (uid, path, files, parent_folders_id = [], storageLeft = 1000000) => (
  new Promise((resolve, reject) => {
    const promises = [];
    const finalPromises = [];
    const current_folder_id = [...parent_folders_id].pop();

    const metadata = {
      customMetadata: {
        uid,
        // dek?
      },
    };

    // force refresh token in order to get user's customClaims; including dek
    firebaseAuth().currentUser.getIdToken(true).then(() => {
      let fullSize = 0;

      files.forEach((file) => {
        const uploadTask = storage.ref(`/${uid}/${path}/${file.name}`).put(file, metadata);
        promises.push(uploadTask);
        fullSize += parseInt(file.size, 10);
      });

      // below should be handled server side instead...
      if (fullSize > storageLeft) {
        return reject(new Error('Not enough space left'));
      }

      Promise.all(promises).then((tasks) => {
        console.log('all file uploads complete: ', tasks);
        const allMetas = [];
        tasks.forEach((file) => {
          // console.log(file);
          const toPush = {
            metadata: file.metadata,
            fullPath: file.metadata.fullPath,
            name: file.metadata.name,
            size: file.metadata.size,
            created_at: file.metadata.timeCreated,
            type: 'file',
            path,
            parent_folders_id,
            folder_id: current_folder_id,
          };
          allMetas.push(toPush);
          const getUrl = storage.ref(file.metadata.fullPath).getDownloadURL();
          finalPromises.push(getUrl);
          // fullSize += parseInt(file.metadata.size, 10);
        });
        Promise.all(finalPromises).then((endResult) => {
          endResult.forEach((item, index) => {
            allMetas[index].url = item;
          });
          console.log('AND THE FINAL ARRAY WITH DOWNLOAD URL IS: ', allMetas);
          console.log('total size of files added: ', fullSize);
          store.dispatch(reduceStorageUser(fullSize));
          createMongoFiles(allMetas);
          return resolve(allMetas);
        }).catch((e) => {
          console.log('error uploading files: ', e);
          return reject(new Error('Error uploading files'));
        });
      });
    });
  })
);

export {
  storage,
  uploadFile,
  uploadFiles,
  deleteFiles,
  analytics,
  firebaseDb,
  firebaseAuth as default,
};
